// src/sections/AusrichtungUndNeigungSection.jsx
import React from "react";
import { useState, useEffect } from "react";
import axios from "axios";
import { showSuccess, showError } from "../utils/toastUtils";
import { Box, Button } from "@chakra-ui/react";

export default function AusrichtungUndNeigungSection({ selectedAnlageId }) {
  const options = [
    "Süd",
    "Ost",
    "West",
    "Ost/West",
    "Nord",
    "Süd/Ost",
    "Süd/West",
    "Nord/Ost",
    "Nord/West",
    "andere",
  ];

  const [checkedValues, setCheckedValues] = useState([]);


  // ✅ LOAD existing data
  useEffect(() => {
    if (!selectedAnlageId) return;

    axios
      .get(`${process.env.REACT_APP_API_URL}/api/ausrichtungneigung/anlage/${selectedAnlageId}`)
      .then((res) => {
        const data = res.data;
        const loaded = [];

        if (data.sued) loaded.push("Süd");
        if (data.ost) loaded.push("Ost");
        if (data.west) loaded.push("West");
        if (data.ostWest) loaded.push("Ost/West");
        if (data.nord) loaded.push("Nord");
        if (data.suedOst) loaded.push("Süd/Ost");
        if (data.suedWest) loaded.push("Süd/West");
        if (data.nordOst) loaded.push("Nord/Ost");
        if (data.nordWest) loaded.push("Nord/West");
        if (data.andere) loaded.push("andere");

        setCheckedValues(loaded);
      })
      .catch(() => setCheckedValues([]));
  }, [selectedAnlageId]);




  const handleSave = async () => {
const checked = checkedValues;

    const payload = {
      anlage: { id: selectedAnlageId },
      sued: checked.includes("Süd"),
      ost: checked.includes("Ost"),
      west: checked.includes("West"),
      ostWest: checked.includes("Ost/West"),
      nord: checked.includes("Nord"),
      suedOst: checked.includes("Süd/Ost"),
      suedWest: checked.includes("Süd/West"),
      nordOst: checked.includes("Nord/Ost"),
      nordWest: checked.includes("Nord/West"),
      andere: checked.includes("andere"),
    };

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/ausrichtungneigung/anlage/${selectedAnlageId}`
      );

      // update
      await axios.put(
        `${process.env.REACT_APP_API_URL}/api/ausrichtungneigung/${res.data.id}`,
        payload
      );

      showSuccess("Gespeichert", "Ausrichtung und Neigung aktualisiert");
    } catch {
      // create
      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/ausrichtungneigung`,
        payload
      );

      showSuccess("Gespeichert", "Ausrichtung und Neigung gespeichert");
    }
  };

  return (
     <Box 
         p={8} 
         bg="white" 
         borderRadius="xl" 
         boxShadow="md" 
         mt={6} 
         mb={10} 
         maxW="fit-content"
       >
      <h3
        style={{
          marginBottom: 16,
          color: "#000000",
          fontWeight: "700",
          textTransform: "uppercase",
          marginLeft: 0,
          fontSize: "24px"
        }}
      >
        AUSRICHTUNG UND NEIGUNG DER MODULE
      </h3>

      <div
        style={{
          background: "#f7fafc",
          padding: 16,
          borderRadius: 8,
          display: "grid",
          gridTemplateColumns: "repeat(6, minmax(0, 1fr))",
          gap: 12,
        }}
      >
        {options.map((opt) => (
          <label
            key={opt}
            style={{ display: "flex", alignItems: "center", gap: 8 }}
          >
            <input
              type="checkbox"
              value={opt}
              checked={checkedValues.includes(opt)}
              onChange={(e) =>
                setCheckedValues((prev) =>
                  e.target.checked
                    ? [...prev, opt]
                    : prev.filter((v) => v !== opt)
                )
              }
            />
            <span>{opt}</span>
          </label>
        ))}
      </div>

      <Button
        type="button"
        bg="#B8860B"
         _hover={{ bg: "#C99414" }}
        size="lg"
        width="fit-content" 
        onClick={handleSave}
      >
        Speichern Ausrichtung und Neigung
      </Button>
    </Box>
  );
}